import { Link } from 'react-router-dom';

export default function HomeHero() {
  return (
    <section className="relative min-h-screen flex items-end pb-0">
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/02b27142bc4e5e219b08b5ae3e646008.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 sm:px-6 lg:px-10 pb-16 sm:pb-24 pt-32 sm:pt-40">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.3em] text-[#C8923A] mb-4 sm:mb-6 animate-fade-in delay-100 font-medium">
            Southeast Michigan &amp; Nearby Ohio
          </p>
          <h1 className="font-cormorant text-5xl sm:text-6xl lg:text-8xl font-light text-white leading-[1.05] mb-6 sm:mb-8 animate-fade-in-up delay-200">
            Moving Made <br />
            <em className="not-italic font-semibold">Easier.</em>
          </h1>
          <p className="text-base sm:text-lg text-white/85 leading-relaxed max-w-xl mb-8 sm:mb-10 animate-fade-in-up delay-300">
            I'm Kendrick Taylor — former home inspector turned realtor. Real knowledge, honest guidance, and a smooth experience from start to close.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 animate-fade-in-up delay-400">
            <Link
              to="/contact"
              className="px-6 sm:px-8 py-3.5 sm:py-4 bg-[#C8923A] text-white font-semibold text-sm tracking-wide rounded-md hover:bg-[#B07B2A] transition-all whitespace-nowrap text-center"
            >
              Let's Talk About Your Move
            </Link>
            <Link
              to="/selling"
              className="px-6 sm:px-8 py-3.5 sm:py-4 border border-white/60 text-white font-semibold text-sm tracking-wide rounded-md hover:bg-white/10 transition-all whitespace-nowrap text-center"
            >
              Request Home Value
            </Link>
          </div>
        </div>
      </div>

      {/* Kendrick badge — hidden on very small screens to avoid clutter */}
      <div className="hidden sm:block absolute bottom-6 sm:bottom-8 right-5 sm:right-6 lg:right-10 z-10 animate-fade-in delay-500">
        <div className="bg-white/10 backdrop-blur-md border border-white/20 px-4 sm:px-5 py-2.5 sm:py-3 rounded-md text-white text-center">
          <p className="text-xs text-white/70 mb-0.5">Kendrick Taylor</p>
          <p className="text-sm font-semibold">Realtor · XSell Realty</p>
        </div>
      </div>
    </section>
  );
}
